import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { LkpStoresModel } from '../models/LkpStoresModel';
import { URLsConfig } from '../URLsConfig';
@Injectable()
export class LkpStoresService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

    public getStores(strCode : string,comCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", comCode);
      params = params.append("StrCode", strCode);

      const options = {
        params: params
      };
      return this.http.get<LkpStoresModel>(this.urlsconfig.WebAPIURL_Test + 'api/LkpStores/GetStores', options);
    }

    public AddStores(bank: LkpStoresModel) {
      return this.http.post<LkpStoresModel>(this.urlsconfig.WebAPIURL_Test + 'api/LkpStores/AddStores', bank);
    }

    public DelStores(strCode : string,comCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", comCode);
      params = params.append("StrCode", strCode);

      const options = {
        params: params
      };
      return this.http.get<LkpStoresModel>(this.urlsconfig.WebAPIURL_Test + 'api/LkpStores/DeleteStores', options);
    }


  public LkpStoresLookupTop(compcode : string) {
    let params = new HttpParams();
    params = params.append("compCode", compcode);
    const options = {

        params: params
    };
    return this.http.get<LkpStoresModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/LkpStores/LkpStoresLookupTop',options);
}

}
